import { apiClient, unwrap } from './client';
import type { ApiResponse, PagedResult } from '@/types/api';
import type { CommandDto } from '@/types/command';
import type {
  CreateDeviceRequest,
  DeviceAuditEntryDto,
  DeviceDetailDto,
  DeviceDto,
  DeviceListRequest,
  QuickCommandRequest,
  UpdateDeviceRequest,
} from '@/types/device';

export const devicesApi = {
  list(request: DeviceListRequest = {}): Promise<PagedResult<DeviceDto>> {
    return unwrap(apiClient.get<ApiResponse<PagedResult<DeviceDto>>>('/devices', { params: request }));
  },
  getById(id: number): Promise<DeviceDto> {
    return unwrap(apiClient.get<ApiResponse<DeviceDto>>(`/devices/${id}`));
  },
  getDetail(id: number): Promise<DeviceDetailDto> {
    return unwrap(apiClient.get<ApiResponse<DeviceDetailDto>>(`/devices/${id}/detail`));
  },
  listCommands(id: number, page = 1, pageSize = 20): Promise<PagedResult<CommandDto>> {
    return unwrap(apiClient.get<ApiResponse<PagedResult<CommandDto>>>(`/devices/${id}/commands`, {
      params: { page, pageSize },
    }));
  },
  listAudit(id: number, page = 1, pageSize = 50): Promise<PagedResult<DeviceAuditEntryDto>> {
    return unwrap(apiClient.get<ApiResponse<PagedResult<DeviceAuditEntryDto>>>(`/devices/${id}/audit`, {
      params: { page, pageSize },
    }));
  },
  quickCommand(id: number, request: QuickCommandRequest): Promise<CommandDto> {
    return unwrap(apiClient.post<ApiResponse<CommandDto>>(`/devices/${id}/quick-command`, request));
  },
  create(request: CreateDeviceRequest): Promise<DeviceDto> {
    return unwrap(apiClient.post<ApiResponse<DeviceDto>>('/devices', request));
  },
  update(id: number, request: UpdateDeviceRequest): Promise<DeviceDto> {
    return unwrap(apiClient.put<ApiResponse<DeviceDto>>(`/devices/${id}`, request));
  },
  deactivate(id: number): Promise<void> {
    return apiClient.delete(`/devices/${id}`).then(() => undefined);
  },
};
